module.exports = __webpack_public_path__ + "media/images/MR_inspiration-5bb14601.png";